module.exports = __webpack_public_path__ + "static/media/iphone.596e845c.png";